module.exports = {"152501200":"格日勒敖都苏木","152501400":"二连浩特市社区建设管理局","152501401":"二连边境经济技术合作区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/152501.json
// module id = 571
// module chunks = 0